import './SensorData.scss';
import React, { useEffect, useState } from "react";
import viirsIcon from '../../../assets/icons/viirs.png';
import modisIcon from '../../../assets/icons/modis.png';
import mapboxgl from 'mapbox-gl';
import { DataGrid } from '@mui/x-data-grid';
import { useSensorDataContext } from '../../../contexts/SensorDataContext.js';
import warningIcon from '../../../assets/icons/warning-icon.png';
import sensorDataIcon from '../../../assets/icons/table-icon.png';
import Spinner from '../../Spinner.js';
import { useUserContext } from '../../../contexts/UserContext';

export default function SensorData(props) {
    const {
        is3D,
        setIs3D
    } = useUserContext();

    const {
        viirs,
        modis
    } = useSensorDataContext()

    const {
        map,
        area,
        setPanel
    } = props;

    const [stage, setStage] = useState('VIIRS');

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'VIIRS':
                return (
                    viirs ?
                    <div className='sensor-data-page-content-data'>
                        <div className='sensor-data-page-content-data-title'>
                            <img className='sensor-data-page-content-data-title-icon' src={viirsIcon}/>
                            <div className='sensor-data-page-content-data-title-text'>{`VIIRS Thermal Hotspots (${viirs.length.toLocaleString()})`}</div>
                        </div>
                        {viirs.length > 0 ? 
                        <DataGrid
                            rows={viirs.map((viir) => ({
                                id: viir.id,
                                timestamp: viir.properties.acq_date ? `${new Date(viir.properties.acq_date).toLocaleDateString()} ${new Date(viir.properties.acq_date).toLocaleTimeString()}` : 'N/A',
                                satellite: viir.properties.satellite ? viir.properties.satellite : 'N/A',
                                brightness: viir.properties.bright_ti4 ? viir.properties.bright_ti4 : 'N/A',
                            }))}
                            columns={viirsColumns}
                            sx={{
                                boxShadow: 'none',
                                fontFamily: "Avenir Next Regular",
                                border: 'none',
                                color: 'white',
                                borderColor: 'white',
                                '& .MuiDataGrid-scrollbarFiller': {
                                    backgroundColor: 'rgb(59, 59, 59)'
                                },
                                '& .MuiCheckbox-root' : {
                                    color: 'white',
                                    filter: 'invert(100%)'
                                },
                                '& .MuiDataGrid-columnHeader' : {
                                    color: 'white',
                                    backgroundColor: 'rgb(59, 59, 59)',
                                },
                                '& .MuiDataGrid-footerContainer' : {
                                    backgroundColor: 'rgb(59, 59, 59)'
                                },
                                '& .MuiTablePagination-displayedRows' : {
                                    color: 'white'
                                },
                                '& .MuiTablePagination-root' : {
                                    color: 'white'
                                },
                                '& .MuiSvgIcon-root' : {
                                    filter: 'invert(100%)'
                                },
                                '& .Mui-disabled' : {
                                    filter: 'invert(100%)'
                                },
                                '& .MuiTablePagination-actions' : {
                                    filter: 'invert(100%)'
                                },
                                '& .MuiDataGrid-columnSeparator': {
                                    filter: 'invert(100%)'
                                }
                            }}
                            initialState={{
                            pagination: {
                                paginationModel: {
                                pageSize: 10,
                                },
                            },
                            }}
                            pageSizeOptions={[5]}
                            checkboxSelection={false}
                            disableRowSelectionOnClick
                        />
                        :
                        <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'white', paddingTop: '0.5rem' }}>There are no VIIRS in your current Monitoring Area.</div>
                        }
                    </div>
                    :
                    <Spinner />
                )
            case 'MODIS':
                return (
                    modis ?
                    <div className='sensor-data-page-content-data'>
                        <div className='sensor-data-page-content-data-title'>
                            <img className='sensor-data-page-content-data-title-icon' src={modisIcon}/>
                            <div className='sensor-data-page-content-data-title-text'>{`MODIS Thermal Hotspots (${modis.length.toLocaleString()})`}</div>
                        </div>
                            {modis.length > 0 ? 
                            <DataGrid
                                rows={modis.map((modis) => ({
                                    id: modis.id,
                                    timestamp: modis.properties.ACQ_DATE ? `${new Date(modis.properties.ACQ_DATE).toLocaleDateString()} ${new Date(modis.properties.ACQ_DATE).toLocaleTimeString()}` : 'N/A',
                                    satellite: modis.properties.SATELLITE ? modis.properties.SATELLITE : 'N/A',
                                    brightness: modis.properties.BRIGHT_TI4 ? modis.properties.BRIGHT_TI4 : 'N/A',
                                }))}
                                columns={modisColumns}
                                sx={{
                                    boxShadow: 'none',
                                    fontFamily: "Avenir Next Regular",
                                    border: 'none',
                                    color: 'white',
                                    borderColor: 'white',
                                    '& .MuiDataGrid-scrollbarFiller': {
                                        backgroundColor: 'rgb(59, 59, 59)'
                                    },
                                    '& .MuiCheckbox-root' : {
                                        color: 'white',
                                        filter: 'invert(100%)'
                                    },
                                    '& .MuiDataGrid-columnHeader' : {
                                        color: 'white',
                                        backgroundColor: 'rgb(59, 59, 59)',
                                    },
                                    '& .MuiDataGrid-footerContainer' : {
                                        backgroundColor: 'rgb(59, 59, 59)'
                                    },
                                    '& .MuiTablePagination-displayedRows' : {
                                        color: 'white'
                                    },
                                    '& .MuiTablePagination-root' : {
                                        color: 'white'
                                    },
                                    '& .MuiSvgIcon-root' : {
                                        filter: 'invert(100%)'
                                    },
                                    '& .Mui-disabled' : {
                                        filter: 'invert(100%)'
                                    },
                                    '& .MuiTablePagination-actions' : {
                                        filter: 'invert(100%)'
                                    },
                                    '& .MuiDataGrid-columnSeparator': {
                                        filter: 'invert(100%)'
                                    }
                                }}
                                initialState={{
                                pagination: {
                                    paginationModel: {
                                    pageSize: 10,
                                    },
                                },
                                }}
                                pageSizeOptions={[5]}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                            />
                            :
                            <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'white', paddingTop: '0.5rem' }}>There are no MODIS in your current Monitoring Area.</div>
                            }
                    </div>
                    :
                    <Spinner />
                )
        }
    }

    const viirsColumns = [
        {
          field: 'timestamp',
          headerName: 'Timestamp',
          width: 200,
          resizeable: false
        },
        {
          field: 'satellite',
          headerName: 'Satellite',
          width: 80,
          resizeable: false
        },
        {
          field: 'brightness',
          headerName: 'Brightness (K)',
          width: 120,
          resizeable: false
        },
        {
          field: 'actions',
          headerName: '',
          width: 100,
          resizeable: false,
          flex: 1,
          align: 'center',
          renderCell: (params) => (           
            <div
            className='sensor-data-page-content-data-view-btn-container-btn'
            onClick={() => {
                const viir = viirs.find((v) => v.id === params.row.id);
                const location = viir.geometry.coordinates;
                map.current.flyTo({center: location, zoom: 11, pitch: 0, offset: [250, 0]});

                if (is3D) {
                    setIs3D(false);
                }
            }}>View</div>
          ),
          cellClassName: 'sensor-data-page-content-data-view-btn-container'
        }
    ];

    const modisColumns = [
        {
          field: 'timestamp',
          headerName: 'Timestamp',
          width: 200,
          resizeable: false
        },
        {
          field: 'satellite',
          headerName: 'Satellite',
          width: 80,
          resizeable: false
        },
        {
          field: 'brightness',
          headerName: 'Brightness (K)',
          width: 120,
          resizeable: false
        },
        {
          field: 'actions',
          headerName: '',
          width: 100,
          resizeable: false,
          flex: 1,
          align: 'center',
          renderCell: (params) => (           
            <div
            className='sensor-data-page-content-data-view-btn-container-btn'
            onClick={() => {
                const viir = modis.find((v) => v.id === params.row.id);
                const location = viir.geometry.coordinates;
                map.current.flyTo({center: location, zoom: 11, pitch: 0, offset: [250, 0]});

                if (is3D) {
                    setIs3D(false);
                }
            }}>View</div>
          ),
          cellClassName: 'sensor-data-page-content-data-view-btn-container'
        }
    ];

    return (
        <div className='sensor-data-page'>
            <div className='sensor-data-page-title'>
                <img className='sensor-data-page-title-icon' src={sensorDataIcon}/>
                <div className='sensor-data-page-title-text'>Sensor Data</div>
            </div>
            <div className='sensor-data-page-description'>Comprehensive wildfire sensor data, featuring detailed information from VIIRS, MODIS, and RAWS.</div>
            <div className='sensor-data-page-area-info'>
                <img src={warningIcon} className='sensor-data-page-area-info-icon'/>
            </div>
            <div className='sensor-data-page-content-tabs'>
                {['VIIRS', 'MODIS'].map((t, index) => (
                    <div
                        key={index}
                        className='sensor-data-page-content-tabs-tab'
                        style={{
                            borderBottom: t === stage ? '2px solid #0080ff' : ''
                        }}
                        onClick={() => setStage(t)}
                    >
                        {t}
                    </div>
                ))}
            </div>
            {stageSwitch(stage)}
        </div>
    );
}